<template>
  <div>
    <b-row>
      <b-col sm="4">
        <b-input type="text" placeholder="Type to search" v-model.trim="filter"></b-input>
      </b-col>
    </b-row><br/>
    <b-row>
      <b-col sm="12" md="12">
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="getRecords" :fields="fields" :per-page="perPage" :current-page="currentPage" :filter="filter">
          <template v-slot:cell(sn)="data">
            {{ data.index + 1 + ((currentPage - 1) * perPage) }}
          </template>
          <template v-slot:cell(action)="data">
            <b-btn class="btn-sm" variant="success" @click="checkDupliate(data.item)">Check Duplicate</b-btn>
          </template>
          <template v-slot:cell(Status)="data">
            <b-badge variant="success" v-if="parseInt(data.item.Status) === 0">Active</b-badge>
            <b-badge variant="danger" v-else-if="parseInt(data.item.Status) === 1">Disable</b-badge>
            <b-badge variant="warning" v-else-if="parseInt(data.item.Status) === 2">Frozen</b-badge>
          </template>
          <template v-slot:cell(Level)="data">
            <b-badge v-if="parseInt(data.item.Level) === 1" variant="danger">Level 1</b-badge>
            <b-badge  v-if="parseInt(data.item.Level) === 2" variant="warning">Level 2</b-badge>
          </template>
          <template v-slot:cell(DepositAmount)="data">
            {{ format(data.item.DepositAmount, '0,0.00') }}
          </template>
          <template v-slot:cell(WithdrawAmount)="data">
            {{ format(data.item.WithdrawAmount, '0,0.00') }}
          </template>
          <template v-slot:cell(PromotionAmount)="data">
            {{ format(data.item.PromotionAmount, '0,0.00') }}
          </template>
          <template v-slot:cell(Turnover)="data">
            {{ format(data.item.Turnover, '0,0.00') }}
          </template>
          <template v-slot:cell(NetWin)="data">
            {{ format(data.item.NetWin, '0,0.00') }}
          </template>
        </b-table>
        <nav>
          <b-pagination :total-rows="getRowCount(getRecords)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import numeral from 'numeral'

export default {
  name: 'high-abnormal-bet-detail-table',
  props: {
    details: {
      type: Array,
      default: []
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      fields: [
        {key: 'sn', label: 'SN', thStyle: { width: '50px' }},
        {key: 'Username', label: 'Username'},
        {key: 'MachineNo', label: 'Machine No'},
        {key: 'LastLoginTime', label: 'Last Login Time'},
        {key: 'LastLoginIP', label: 'LastLoginIP'},
        {key: 'Level', label: 'Level'},
        {key: 'Status', label: 'Status'},
        {key: 'Branch', label: 'Branch'},
        {key: 'DepositAmount', label: 'Total Deposit'},
        {key: 'WithdrawAmount', label: 'Total Withdraw'},
        {key: 'PromotionAmount', label: 'Total Promotion'},
        {key: 'Turnover', label: 'Turnover'},
        {key: 'NetWin', label: 'NetWin'}
      ],
      filter: '',
      currentPage: 1,
      perPage: 30
    }
  },
  computed: {
    getRecords: function () {
      return this.details
    }
  },
  methods: {
    format (num, fmt) {
      return numeral(num).format(fmt)
    },
    getRowCount (items) {
      return items.length
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/report/risk/game/DuplicateAccountDetail.vue